export default {
  data () {
    return {
      skipScroll: false
    }
  },
  methods: {
    scrollToBottom (force) {
      this.$nextTick(() => {
        this.$el.parentElement.scrollTop = this.$el.parentElement.scrollHeight - this.$el.parentElement.clientHeight
      })
    }
  },
  updated () {
    if (this.skipScroll) return
    this.scrollToBottom()
  },
  mounted () {
    this.scrollToBottom()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollableToBottom.js